import React from "react";
import styled from "styled-components";

export default styled.div`
    font-family: 'Effra', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #ED6D5F;
    
    i {
        margin-right: 20px;
    }
`;